module.exports = __webpack_public_path__ + "static/aetna-a9aa0feb8ac1268810fb75963f5a6c4f.png";